module.exports = __webpack_public_path__ + "static/media/corporate-cover.b4074fd5.jpg";